import { useEffect, useState } from 'react'
import {
  View,
  Text,
  ScrollView,
  TouchableOpacity,
  StyleSheet,
  Pressable,
  TextInput,
  ActivityIndicator,

} from 'react-native'
import { fontPalette, globalStyles } from '../../static/styles/global'
import HomeDetailsHeader from '../../components/home/HomeDetailsHeader'
import Card from '../../components/shared/card/Card'

import { useLabourStore } from '../../stores/labour'
import { useshiftstore } from '../../stores/shift'
import { useInitializeStore } from '../../stores/initialize'
import Toast from 'react-native-toast-message'
import moment from 'moment'
import CustomTimePickerModal from '../../components/shared/calendar/CustomTimePickerModal'
import AsyncStorage from '@react-native-async-storage/async-storage'
import SelectKeyValue from '../../components/shared/form/SelectKeyValue'
import CustomDatePickerModal from '../../components/shared/calendar/CustomDatePickerModal'
import { useTranslation } from 'react-i18next'
import LeaveBalancesCards from './LeaveBalancesCards'

const EmployeeRequest = ({ navigation, route }: any) => {
  const [ptoHours, setPtoHours] = useState('8')
  const [comments, setComments] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)
  const shiftStore = useshiftstore()
  const labourstore = useLabourStore()
  const initializeStore = useInitializeStore()

  const [startWebDate, setStartWebDate] = useState(
    moment(new Date()).format('YYYY-MM-DD')
  )
  const [endWebDate, setEndWebDate] = useState(
    moment(new Date()).format('YYYY-MM-DD')
  )
  const [startWebTime, setStartWebTime] = useState('09:00 AM')
  const [endWebTime, setEndWebTime] = useState('05:00 PM')
  const [visibleStart, setVisibleStart] = useState(false)
  const [visibleEnd, setVisibleEnd] = useState(false)
  const [visibledate, setVisibleDate] = useState(false)
  const [visibleEndDate, setVisibleEndDate] = useState(false)
  const [timeoffcode, setTimeoffCode] = useState('')
  const [disable, setDisable] = useState(true)

  useEffect(() => {
    shiftStore.geteccodelist(labourstore.labourData?.entityId)
    const fetchLeaveBalances = async () => {
      const userKey =
        initializeStore.initializeData?.userkey
      if (userKey) {
        shiftStore.getLeaveBalances(userKey)
      }
    }
    fetchLeaveBalances()
  }, [labourstore.labourData?.entityId, initializeStore.initializeData?.userkey])


  const chageStartTime = (fromTime: any) => {
    setVisibleStart(false)
    setStartWebTime(fromTime)
    let sTime = moment(fromTime, 'h:mm A')
    let eTime = moment(endWebTime, 'h:mm A')
    let timeDifferenceInMilliseconds = eTime.utc().diff(sTime.utc())
    let n = moment(endWebDate).diff(startWebDate, 'days')

    let duration = moment.duration(timeDifferenceInMilliseconds * (n + 1));
    let totalHours = duration.asHours();
    let hours = Math.floor(totalHours);
    let minutes = Math.floor((totalHours - hours) * 60);
    let pto = hours + ':' + String(minutes).padStart(2, '0');

    if (sTime.isBefore(eTime)) {
      setPtoHours(pto)
    } else if (sTime.isSame(eTime)) {
      setStartWebTime('09:00 AM')
      setPtoHours('8')
    } else {
      setStartWebTime('09:00 AM')
      setEndWebTime('05:00 PM')
      setPtoHours('8')
    }
  }
  const chageEndTime = (fromTime: any) => {
    setVisibleEnd(false)
    setEndWebTime(fromTime)

    let sTime = moment(startWebTime, 'h:mm A')
    let eTime = moment(fromTime, 'h:mm A')
    let timeDifferenceInMilliseconds = eTime.utc().diff(sTime.utc())
    let n = moment(endWebDate).diff(startWebDate, 'days')
    let duration = moment.duration(timeDifferenceInMilliseconds * (n + 1));
    let totalHours = duration.asHours();
    let hours = Math.floor(totalHours);
    let minutes = Math.floor((totalHours - hours) * 60);
    let pto = hours + ':' + String(minutes).padStart(2, '0');
    if (sTime.isBefore(eTime)) {
      setPtoHours(pto)
    } else if (sTime.isSame(eTime)) {
      setStartWebTime('09:00 AM')
      setPtoHours('8')
    } else {
      setStartWebTime('09:00 AM')
      setEndWebTime('05:00 PM')
      setPtoHours('8')
    }
  }

  const updateTime = (ftime: any) => { }
  const openTimeStart = () => {
    setVisibleStart(true)
  }


  const openTimeEnd = () => {
    setVisibleEnd(true)
  }


  const onChangeComments = (text: any) => {
    setComments(text)
  }

  const onChangeWebStart = (selectedDate: any) => {
    setVisibleDate(false)
    const formattedDate = selectedDate
    setStartWebDate(formattedDate)

    let sTime = moment(startWebTime, 'h:mm A')
    let eTime = moment(endWebTime, 'h:mm A')
    let timeDifferenceInMilliseconds = eTime.utc().diff(sTime.utc())
    let n = moment(endWebDate).diff(formattedDate, 'days')
    let duration = moment.duration(timeDifferenceInMilliseconds * (n + 1));
    let totalHours = duration.asHours();
    let hours = Math.floor(totalHours);
    let minutes = Math.floor((totalHours - hours) * 60);
    let pto = hours + ':' + String(minutes).padStart(2, '0');

    if (formattedDate > endWebDate) {
      setEndWebDate(formattedDate)
      setPtoHours('8')
      // setStartTime(new Date().setHours(defaultStartTime, 0, 0, 0));
      // setEndTime(new Date().setHours(defaultEndTime, 0, 0, 0));
    } else if (
      new Date(formattedDate).getTime() == new Date(endWebDate).getTime()
    ) {
      setPtoHours(pto)
      // setStartTime(new Date().setHours(defaultStartTime, 0, 0, 0));
      // setEndTime(new Date().setHours(defaultEndTime, 0, 0, 0));
    } else if (new Date(formattedDate) < new Date(endWebDate)) {
      // const n = differenceInDays(new Date(endWebDate), new Date(formattedDate))
      // setPtoHours(((n + 1) * 8).toString())
      setPtoHours(pto)
    }
  }

  const onChangeWebEnd = (selectedDate: any) => {
    setVisibleEndDate(false)
    const formattedDate = selectedDate
    setEndWebDate(formattedDate)



    let sTime = moment(startWebTime, 'h:mm A')
    let eTime = moment(endWebTime, 'h:mm A')
    let timeDifferenceInMilliseconds = eTime.utc().diff(sTime.utc())
    let n = moment(formattedDate).diff(startWebDate, 'days')
    let duration = moment.duration(timeDifferenceInMilliseconds * (n + 1));
    let totalHours = duration.asHours();
    let hours = Math.floor(totalHours);
    let minutes = Math.floor((totalHours - hours) * 60);
    let pto = hours + ':' + String(minutes).padStart(2, '0');
    if (formattedDate > startWebDate) {
      setPtoHours(pto)
    } else if (
      new Date(formattedDate).getTime() == new Date(startWebDate).getTime()
    ) {
      setPtoHours(pto)
    } else if (new Date(formattedDate) < new Date(startWebDate)) {
      setStartWebDate(formattedDate)
      setPtoHours('8')
    }
  }

  const submitRequest = async () => {
    setIsSubmitting(true)
    try {
      const startOff = Date.UTC(
        moment(startWebDate, 'YYYY-MM-DD').year(),
        moment(startWebDate, 'YYYY-MM-DD').month(),
        moment(startWebDate, 'YYYY-MM-DD').date(),
        parseInt(moment(startWebTime, 'h:mm A').format('HH:mm').split(':')[0]),
        parseInt(moment(startWebTime, 'h:mm A').format('HH:mm').split(':')[1]),
        0,
        0
      )

      const endOff = Date.UTC(
        moment(endWebDate, 'YYYY-MM-DD').year(),
        moment(endWebDate, 'YYYY-MM-DD').month(),
        moment(endWebDate, 'YYYY-MM-DD').date(),
        parseInt(moment(endWebTime, 'h:mm A').format('HH:mm').split(':')[0]),
        parseInt(moment(endWebTime, 'h:mm A').format('HH:mm').split(':')[1]),
        0,
        0
      )

      console.log('=== PTO Submit Debug ===')
      console.log('Browser timezone:', Intl.DateTimeFormat().resolvedOptions().timeZone)
      console.log('Start date state:', startWebDate)
      console.log('End date state:', endWebDate)
      console.log('startTimeOff ISO:', new Date(startOff).toISOString())
      console.log('endTimeOff ISO:', new Date(endOff).toISOString())

      const essUserKey = await AsyncStorage.getItem('essUserKey')

      const data = {
        essUserKey: essUserKey,
        startTimeOff: new Date(startOff).toISOString(),
        endTimeOff: new Date(endOff).toISOString(),
        ptohours: parseFloat(ptoHours.replace(':', '.')),
        employeeComment: comments.replace(/\((.*?)\)/g, "[$1]"),
        userId: labourstore?.labourData?.userId
          ? labourstore?.labourData?.userId
          : 0,
        ecCode: timeoffcode
      }
      const res = await shiftStore.submitPto(data)
      setIsSubmitting(false)
      if (res?.success) {
        Toast.show({
          type: 'success',
          text1: t(res?.message),
          position: 'bottom',
          onHide: () => {
            navigation.replace('LabourScreen')
          }
        })
      } else {
        Toast.show({
          type: 'error',
          text1: t(res?.message),
          position: 'bottom'
        })
      }
    } catch (error) {

      Toast.show({
        type: 'error',
        text1: t('Something went wrong'),
        position: 'bottom'
      })
    }
  }

  const data =
    shiftStore.codelist?.data?.length > 0 ? shiftStore.codelist?.data : []

  const { t } = useTranslation()
  const getLocalDateWithoutTimeZoneShift = (dateString: any) => {
    const [year, month, day] = dateString.split('-').map(Number);
    return new Date(year, month - 1, day);
  };

  return (
    <ScrollView>
      <View style={[globalStyles.primaryBgColor, { paddingTop: 15, paddingBottom: 16 }]}>
        <View style={[globalStyles.horizontalPadGap]}>
          <HomeDetailsHeader
            title={t('PTO Request & History')} />
        </View>
        <View style={[globalStyles.vCenterItems, { marginBottom: 10 }]}>
          <TouchableOpacity onPress={() => navigation.navigate("PTORequestHistory")} style={{ padding: 16 }}>
            <Text style={{ textAlign: "right", color: "#fff", textDecorationLine: "underline", fontFamily: fontPalette.primaryRegular }}>{t('PTO Request History')}</Text>
          </TouchableOpacity>
        </View>

        {/* Leave Balances Cards Section */}
        <LeaveBalancesCards />

        <View style={{ paddingHorizontal: 20, paddingTop: 16, paddingBottom: 6 }}>
          <Text style={[globalStyles.whiteTextColor, globalStyles.fs15, globalStyles.fwBold]}>{t('PTO Request')}</Text>
        </View>
      </View>
      <View
        style={{
          marginTop: -12,
          padding: 16,
          flex: 1,
          justifyContent: 'space-between'
        }}
      >
        <Card>
          {shiftStore.loading ? (
            <ActivityIndicator />
          ) : (
            <>
              <View style={{ flexDirection: 'row' }}>
                <View style={styles.leftColumn}>
                  <Text style={styles.labelText}>{t('startdate')}</Text>
                </View>
                <View style={styles.rightColumn}>
                  {/* <DatePicker
                onChange={(selectedDate) => onChangeWebStart(selectedDate)}
                value={startWebDate}
              /> */}
                  <Pressable onPress={() => setVisibleDate(true)}>
                    <TextInput
                      style={[styles.ptoBox]}
                      value={startWebDate}
                      editable={false}
                    />
                  </Pressable>
                  <CustomDatePickerModal
                    visible={visibledate}
                    value={startWebDate ? getLocalDateWithoutTimeZoneShift(startWebDate) : new Date()}
                    minimumDate={new Date()}
                    onConfirm={(date) => {
                      const formattedDate = moment(date).format('YYYY-MM-DD')
                      onChangeWebStart(formattedDate)
                    }}
                    onCancel={() => setVisibleDate(false)}
                  />
                </View>
              </View>

              {/* {startWebDate == endWebDate && ( */}
              <View style={{ flexDirection: 'row', marginTop: 10 }}>
                <View style={styles.leftColumn}>
                  <Text style={styles.labelText}>{t('Start Time')}</Text>
                </View>
                <View style={styles.rightColumn}>
                  {/* <TimePicker/> */}
                  <Pressable onPress={openTimeStart}>
                    <TextInput
                      style={[styles.ptoBox]}
                      value={startWebTime}
                      editable={false}
                    />
                  </Pressable>
                  <CustomTimePickerModal
                    visible={visibleStart}
                    value={moment(startWebTime, 'h:mm A').toDate()}
                    onConfirm={(selectedDate) => {
                      const formattedTime = moment(selectedDate).format('hh:mm A')
                      chageStartTime(formattedTime)
                    }}
                    onCancel={() => setVisibleStart(false)}
                  />
                </View>
              </View>
              {/* )} */}
              <View style={{ flexDirection: 'row', marginTop: 20 }}>
                <View style={styles.leftColumn}>
                  <Text style={styles.labelText}>{t('End Date')}</Text>
                </View>
                <View style={styles.rightColumn}>
                  {/* <DatePicker
                onChange={(selectedDate) => onChangeWebEnd(selectedDate)}
                value={endWebDate}
              /> */}
                  <Pressable onPress={() => setVisibleEndDate(true)}>
                    <TextInput
                      style={[styles.ptoBox]}
                      value={endWebDate}
                      editable={false}
                    />
                  </Pressable>
                  <CustomDatePickerModal
                    visible={visibleEndDate}
                    value={endWebDate ? getLocalDateWithoutTimeZoneShift(endWebDate) : new Date()}
                    minimumDate={new Date()}
                    onConfirm={(date) => {
                      const formattedDate = moment(date).format('YYYY-MM-DD')
                      onChangeWebEnd(formattedDate)
                    }}
                    onCancel={() => setVisibleEndDate(false)}
                  />
                </View>
              </View>
              {/* {startWebDate == endWebDate && ( */}
              <View style={{ flexDirection: 'row', marginTop: 10 }}>
                <View style={styles.leftColumn}>
                  <Text style={styles.labelText}>{t('End Time')}</Text>
                </View>
                <View style={styles.rightColumn}>
                  {/* <TimePicker /> */}
                  <Pressable onPress={openTimeEnd}>
                    <TextInput
                      style={[styles.ptoBox]}
                      value={endWebTime}
                      editable={false}
                    />
                  </Pressable>
                  <CustomTimePickerModal
                    visible={visibleEnd}
                    value={moment(endWebTime, 'h:mm A').toDate()}
                    onConfirm={(selectedDate) => {
                      const formattedTime = moment(selectedDate).format('hh:mm A')
                      chageEndTime(formattedTime)
                    }}
                    onCancel={() => setVisibleEnd(false)}
                  />
                </View>
              </View>
              {/* )} */}
              <View style={{ flexDirection: 'row', marginTop: 20 }}>
                <View style={styles.leftColumn}>
                  <Text style={styles.labelText}>{t('PTO Hours')}</Text>
                </View>
                <View style={styles.rightColumn}>
                  <TextInput
                    style={[styles.ptoBox]}
                    value={ptoHours}
                    editable={false}
                  />
                </View>
              </View>

              <View style={{ flexDirection: 'row', marginTop: 20 }}>
                <View style={styles.leftColumn}>
                  <Text style={styles.labelText}>{t('Timeoff Code')}</Text>
                </View>

                <View style={[{ width: '28%', overflow: 'hidden' }]}>
                  <SelectKeyValue
                    title={t('Timeoff Code')}
                    options={data}
                    selectedOption={timeoffcode}
                    onSelect={(option: string) => {
                      setDisable(false)
                      setTimeoffCode(option)
                    }}
                  />
                </View>
              </View>

              <View style={{ flexDirection: 'row', marginTop: 20 }}>
                <View style={styles.leftColumn}>
                  <Text style={styles.labelText}>{t('Comments')}</Text>
                </View>
                <View style={styles.rightColumn}>
                  <TextInput
                    value={comments}
                    style={styles.textBox2}
                    onChangeText={(text) => onChangeComments(text)}
                    multiline
                  />
                </View>
              </View>
            </>
          )}
        </Card>

        {isSubmitting && <ActivityIndicator />}
        {!isSubmitting && !shiftStore.loading && (
          <TouchableOpacity
            style={[
              styles.custom2,
              {
                backgroundColor: disable ? 'gray' : '#9DD086'
              }
            ]}
            onPress={submitRequest}
            disabled={disable}
          >
            <View>
              <Text
                style={{ fontSize: 20, fontFamily: fontPalette.primaryBold, color: 'white' }}
              >
                {t('Submit Request')}
              </Text>
            </View>
          </TouchableOpacity>
        )}

      </View>
    </ScrollView>
  )
}
const styles = StyleSheet.create({
  custom: {
    justifyContent: 'center',
    flexDirection: 'row',
    paddingLeft: 16,
    paddingRight: 16,
    height: 40,
    width: '90%',
    alignItems: 'center',
    backgroundColor: '#0088CF',
    color: 'black',
    borderWidth: 0,
    borderRadius: 11,
    marginTop: 5
  },
  custom2: {
    justifyContent: 'center',
    flexDirection: 'row',
    height: 40,
    width: '95%',
    paddingLeft: 16,
    paddingRight: 16,
    alignItems: 'center',
    alignSelf: 'center',
    borderWidth: 0,
    borderRadius: 10
  },
  labelText: {
    fontSize: 16,
    marginTop: 6,
    fontFamily: fontPalette.primaryRegular
  },
  leftColumn: {
    width: '40%',
    alignItems: 'flex-start'
  },
  rightColumn: {
    width: '60%',
    alignItems: 'flex-start'
  },
  rightColumnWeb: {
    width: '60%',
    alignItems: 'flex-end'
  },
  rowHeading: { flexDirection: 'row', marginTop: 10 },
  textBox1: {
    width: '50%',
    height: 40,
    borderWidth: 0,
    borderColor: '#c3c3c3',
    padding: 3,
    textAlign: 'right',
    fontSize: 17,
    backgroundColor: '#f1f1f1',
    borderRadius: 10,
    paddingRight: 10,
    fontFamily: fontPalette.primaryRegular
  },
  textBox2: {
    width: '100%',
    height: 60,
    borderWidth: 1,
    borderColor: '#c3c3c3',
    padding: 5,
    fontFamily: fontPalette.primaryRegular
  },
  ptoBox: {
    height: 30,
    borderWidth: 1,
    borderColor: '#c3c3c3',
    padding: 5,
    zIndex: 0,
    width: 150,
    fontFamily: fontPalette.primaryRegular
  }
})
export default EmployeeRequest
